import { MDText } from 'i18n-react';

import LocalTexts from './MenuToggle.texts';

const LocalT = new MDText(LocalTexts);

export const getAriaLabel = (isOpen: boolean): string =>
	String(!isOpen ? LocalT.translate('openLabel') : LocalT.translate('closeLabel'));
